// prompts.ts — daily-prompt rotation, ported verbatim from the archived Swift
// PromptBank (Sources/Policy/PromptBank.swift). Deterministic by day-of-year so
// the user sees the same prompt across a calendar day without a server round-trip.
// Warm, first-person, real-people language — no therapy/clinical phrasing.

export const PROMPTS: string[] = [
  "What made you smile today?",
  "One small thing you appreciated about yourself today?",
  "What's a memory from this week you don't want to forget?",
  "What's something you'd like to say but haven't yet?",
  "What did today teach you?",
  "What's one thing you're looking forward to tomorrow?",
  "What did you find difficult today, and what helped?",
  "What's a small kindness you noticed today — given or received?",
  "If today had a soundtrack, what song would it be?",
  "What's something you did today that felt like 'you'?",
  "When did you feel most relaxed today?",
  "What's a question you've been sitting with lately?",
  "What's a meal, taste, or smell that made you happy this week?",
  "Where did you go today — even just to a different room?",
  "What's a quiet moment from today you'd like to remember?",
  "What's one thing you'd like to spend more time on?",
  "What made you laugh today?",
  "What's a tiny win from today worth celebrating?",
  "What's something you're proud of from this week?",
  "What's one thing you'd like to do less of next week?",
  "What's a feeling that's been showing up a lot lately?",
  "Who or what surprised you today, in a good way?",
  "What's a thing you've been putting off that you'd like to start?",
  "What's a place you'd like to be in five minutes if you could teleport?",
  "What's a song, podcast, or quote that stayed with you today?",
  "What's something simple that made today feel good?",
  "What's a question you'd like to sit with this week?",
  "What's an ordinary moment you'd like to bottle up?",
];

// Deterministic prompt for today, by day-of-year in local time.
export function promptForToday(date = new Date()): string {
  const start = new Date(date.getFullYear(), 0, 0);
  const diff = date.getTime() - start.getTime();
  const dayOfYear = Math.floor(diff / 86_400_000);
  const idx = (dayOfYear - 1 + PROMPTS.length) % PROMPTS.length;
  return PROMPTS[idx];
}
